export * from './android-compliance-policy.schema';
export * from './android-compliance-policy.form';

export const tooltips = {
    // add tooltip here

    passwordRequired:
        'This setting specifies whether to require users to enter a password before access is granted to information on their mobile devices. Recommended value: Require',
    passwordRequiredType:
        'Set the password’s complexity requirements. Additional password requirements will become available based on your selection',
    passwordMinimumLength: 'Minimum number of digits or characters required in password. (4-16)',
    passwordMinutesOfInactivityBeforeLock:
        'This setting specifies the length of time without user input after which the mobile device screen is locked. Recommended value: 15 min',
    passwordExpirationDays: 'Number of days until device password must be changed. (1-365)',
    passwordPreviousPasswordCountToBlock:
        'Enter the number of unique passwords required before a user can reuse an old one. (1-24)',
    storageRequireEncryption: 'Require encryption of data storage on device.',
    securityRequireIntuneAppIntegrity:
        'Checks that the Intune app has the default runtime environment installed, and is properly signed.',
    osMinimumVersion:
        'Specify the min OS version compliance requirement for devices. E.g. specify “7.1” in this field for Nougat',
    osMaximumVersion:
        'Specify the max OS version compliance requirement for devices. E.g. specify “7.1” in this field for Nougat',
    minAndroidSecurityPatchLevel: 'Select the oldest security patch level a device can have',
    deviceThreatProtectionRequiredSecurityLevel:
        'Select the maximum allowed device threat level for devices evaluated by your connected Threat Defense services. Devices which exceed this threat level get marked as noncompliant.',
    advancedThreatProtectionRequiredSecurityLevel:
        'Select the maximum allowed machine risk score for devices evaluated by Microsoft Defender for Endpoint. Devices which exceed this score get marked as noncompliant.',
    playIntegrityVerdict: 'Set the level of Play Integrity Verdict',
};
